import {
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_FAILED,
  CHANGE_PASSWORD_SUCCESS,
  CLEAR_CHANGE_PASSWORD_MESSAGE,
  CLEAR_ERROR_AND_SUCCESSFUL,
  CLEAR_FORGOT_PASSWORD_MESSAGE,
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_FAILED,
  FORGOT_PASSWORD_SUCCESS,
  LOGIN_USER,
  LOGIN_USER_FAILED,
  LOGIN_USER_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  SET_USER_INFO,
  SIGNIN,
  SIGNIN_FAILED,
  SIGNIN_SUCCESS,
  SIGN_IN_GUEST,
  SIGN_IN_GUEST_FAILED,
  SIGN_IN_GUEST_SUCCESS,
} from "./constants";

export const loginUser = (email: string, password: string) => ({
  type: LOGIN_USER,
  payload: { email, password },
});

export const loginUserSuccess = (jwtAuthToken: string) => ({
  type: LOGIN_USER_SUCCESS,
  payload: { jwtAuthToken },
});

export const loginUserFailed = () => ({
  type: LOGIN_USER_FAILED,
});

export const logoutUser = () => ({
  type: LOGOUT_USER,
  payload: { history },
});

export const logoutUserSuccess = () => ({
  type: LOGOUT_USER_SUCCESS,
});

export const forgotPassword = (email: string) => ({
  type: FORGOT_PASSWORD,
  payload: { email },
});

export const forgotPasswordSuccess = () => ({
  type: FORGOT_PASSWORD_SUCCESS,
});

export const forgotPasswordFailed = () => ({
  type: FORGOT_PASSWORD_FAILED,
});

export const clearForgotPasswordMessage = () => ({
  type: CLEAR_FORGOT_PASSWORD_MESSAGE,
});

export const changePassword = (password: string, tokenUrl: string) => ({
  type: CHANGE_PASSWORD,
  payload: { password, tokenUrl },
});

export const changePasswordSuccess = () => ({
  type: CHANGE_PASSWORD_SUCCESS,
});

export const changePasswordFailed = () => ({
  type: CHANGE_PASSWORD_FAILED,
});

export const clearChangePasswordMessage = () => ({
  type: CLEAR_CHANGE_PASSWORD_MESSAGE,
});

export const signin = (email: string, password: string) => ({
  type: SIGNIN,
  payload: { email, password },
});

export const signinSuccess = (jwtAuthToken: string) => ({
  type: SIGNIN_SUCCESS,
  payload: { jwtAuthToken },
});

export const signinFailed = (errorMsg: string) => ({
  type: SIGNIN_FAILED,
  payload: { errorMsg },
});

export const signInGuest = (nickname: string) => ({
  type: SIGN_IN_GUEST,
  payload: { nickname },
});

export const signInGuestSuccess = (jwtGuestToken: string) => ({
  type: SIGN_IN_GUEST_SUCCESS,
  payload: { jwtGuestToken, error: false },
});

export const signInGuestFailed = () => ({
  type: SIGN_IN_GUEST_FAILED,
});

export const clearErrorAndSuccessful = () => ({
  type: CLEAR_ERROR_AND_SUCCESSFUL,
});

export const setUserInfo = (jwtToken: string, tokenType: string) => ({
  type: SET_USER_INFO,
  payload: { jwtToken, tokenType },
});
